import styled from 'styled-components';

export const StyledIssuedInvoicesTable = styled.div`
   display: flex;
   flex-direction: column;
   height: 100%;
`;
StyledIssuedInvoicesTable.displayName = 'StyledIssuedInvoicesTable';
